import type { TextChannel } from './TextChannel';
import type { ConversationRepository } from '../ConversationRepository';
import type { PhoneNumber } from '../PhoneNumber';
import type { ConversationId } from '../ConversationId';

const CrossBorderUnreachablePrefixes: Record<string, string> = {
  GB: '+44',
};

export class SmsChannel implements TextChannel {
  static readonly MessageLengthLimit = 320;

  static canReach(phoneNumber: string, facilityCountryCode: string): boolean {
    return !Object.entries(CrossBorderUnreachablePrefixes).some(
      ([country, prefix]) => country !== facilityCountryCode && phoneNumber.startsWith(prefix),
    );
  }

  constructor(
    private readonly messageRepository: ConversationRepository,
    readonly isRecipientReachable = true,
  ) {}

  readonly hasToInitializeWithTemplate = false;

  get canSendFreeFormMessages(): boolean {
    return this.isRecipientReachable;
  }

  readonly canSendAttachments = false;

  readonly canSendVoiceRecordings = false;

  readonly messageLengthLimit = SmsChannel.MessageLengthLimit;

  async sendMessage(
    conversationId: ConversationId,
    phoneNumber: PhoneNumber,
    body: string,
  ): Promise<void> {
    if (!conversationId.value) {
      return this.messageRepository.create(phoneNumber, body);
    }

    return this.messageRepository.addMessage(conversationId, body);
  }
}
